import { useMutation } from '@apollo/client';
import Modal from 'pageComponents/_common/modal';
import React, { useContext, useState } from 'react';
import MyContext from 'setup/context';
import { ADD_PRODUCT_IN_STOCK_NOTIFICATION } from 'setup/gqlQueries/notifyWhenAvailableQueries';
import styled from 'styled-components';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';
import Loader from 'pageComponents/_common/loader';

const NMButton = styled.button`
    color: white;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: 'white !important';
    background: #0368e0;
    background: linear-gradient(to top left, #0368e0, #328efc);
    padding: 4px 12px;
    box-shadow: 1px 1px 2px black;
    font-size: 12px;
    font-weight: 600;
    border: none;
    margin: 5px;
    svg {
        margin-right: 5px;
    }
    &:hover {
        color: white;
        text-decoration: none;
    }
`
const NMButtonNo = styled(NMButton)`
    background: white;
    border: 1px solid #0368e0;
    color: black;
    &:hover {
        color: black;
        text-decoration: none;
    }
`

const NMButtonDone = styled(NMButton)`
    background: #00cc00;
    border: 1px solid #00b300;
`

const Container = styled.div`
    margin: 10px;
`

const DivRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`

const SpanError = styled.div`
    color: #DB1633;
    font-size: 12px;
    font-weight: 500;
`

const PTip = styled.p`
    font-style: italic;
`

export default function NotifyMeButton(props) {
    const {
        onOrder
    } = props
    
    const [openNotifyModal, setOpenNotifyModal] = useState(false)
    const [openWeGotYouModal, setOpenWeGotYouModal] = useState(false)
    const [notificationMessage, setNotificationMessage] = useState(null)
    const context = useContext(MyContext)
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [emailAddress, setEmailAddress] = useState("")

    const [addInStockNotification, { loading: notificationLoading }] = useMutation(ADD_PRODUCT_IN_STOCK_NOTIFICATION, {
        onCompleted: data => {
            if (data.addWatchedProduct.success === true) {
                setNotificationMessage(null)
                setOpenNotifyModal(false)
            } else {
                setNotificationMessage(`${data.addWatchedProduct.message}, problem code ${data.addWatchedProduct.logId}`)
            }
        },
        onError: () => {
            setNotificationMessage("There was a problem and we couldn't set up your notification request.")
        }
    })

    if(!onOrder) return

    function doNotifyWebUser() {
        addInStockNotification({
            variables: {
                invMastUid: onOrder.invMastUid
            }
        })
    }

    function doNotifyAnon() {
        addInStockNotification({
            variables: {
                invMastUid: onOrder.invMastUid,
                firstName: firstName,
                lastName: lastName,
                emailAddress: emailAddress
            }
        })
    }

    if (onOrder.isBeingWatched) {
        //Already watching
        return <>
            <Modal open={openWeGotYouModal} onClose={() => setOpenWeGotYouModal(false)}>
                <Container>
                    <h4>We Got You</h4>
                    <h6>We'll send you an email when this product becomes available.</h6>
                    <DivRow>
                        <NMButtonDone onClick={() => setOpenWeGotYouModal(false)}><CheckIcon />Ok</NMButtonDone>
                    </DivRow>
                    <PTip>Don't need this any more? You can unwatch this product in <Link to="/account/notifications">My Account</Link></PTip>
                </Container>
            </Modal>
            <NMButtonDone onClick={() => setOpenWeGotYouModal(true)}><CheckIcon />Notification On</NMButtonDone>
        </>
    }
    else 
    {
        if (context.userInfo?.isWebUser) {
            //Known User
            return <>
                <Modal open={openNotifyModal} onClose={() => setOpenNotifyModal(false)} contentStyle={{ borderRadius: 5, padding: 16 }}>
                    <Container>
                        <h4>Notify Me</h4>
                        <h6 style={{ textAlign: "center" }}>Hi {context.userInfo.preferredName}, we currently have {onOrder.receiptQtyDueIn} of this item on order. Would you like to be notified when some arrive?</h6>
                        {notificationMessage && <SpanError>{notificationMessage}</SpanError>}
                        {notificationLoading && <Loader />}
                        <DivRow>
                            <NMButton onClick={doNotifyWebUser} ><NotificationsIcon />Yes please!</NMButton>
                            <NMButtonNo onClick={() => setOpenNotifyModal(false)}>No thanks</NMButtonNo>
                        </DivRow>
                    </Container>
                </Modal>
                <NMButton onClick={() => setOpenNotifyModal(true)}><NotificationsIcon />Notify Me</NMButton>
            </>
        } else {
            //Anonymous
            return <>
                <Modal open={openNotifyModal} onClose={() => setOpenNotifyModal(false)} contentStyle={{ borderRadius: 5, padding: 16 }}>
                    <Container>
                        <h4>Notify Me</h4>
                        <h6 style={{ textAlign: "center" }}>We currently have {onOrder.receiptQtyDueIn} of this item on order. Would you like to be notified when some arrive?</h6>
                        <form>
                            <table style={{ margin: "auto" }}>
                                <tbody>
                                    <tr>
                                        <td><label>Your First Name</label></td>
                                        <td><input key="firstName" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}></input></td>
                                    </tr>
                                    <tr>
                                        <td><label>Your Last Name</label></td>
                                        <td><input key="lastName" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}></input></td>
                                    </tr>
                                    <tr>
                                        <td><label>Your Email Address</label></td>
                                        <td><input key="emailAddress" type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}></input></td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        {notificationMessage && <SpanError>{notificationMessage}</SpanError>}
                        {notificationLoading && <Loader />}
                        <DivRow>
                            <NMButton onClick={doNotifyAnon}><NotificationsIcon />Yes please!</NMButton>
                            <NMButtonNo onClick={() => setOpenNotifyModal(false)}>No thanks</NMButtonNo>
                        </DivRow>
                        <PTip>Tip: If you have an account, sign in first so you can manage your notifications.</PTip>
                    </Container>
                </Modal>
                <NMButton onClick={() => setOpenNotifyModal(true)}><NotificationsIcon />Notify Me</NMButton>
            </>
        }
    }
}
